<template>
    <div>
        <Tooltip :disabled="!disabled" :max-width="400" :content="originalValue.map(i=>i.label).join(',')">
            <Select :disabled="disabled" placeholder="请输入中文名称进行搜索" :value="value" ref="selectRef" multiple :max-tag-count="1" :loading="loading"
                @on-change="handleChangeOption" filterable @on-query-change="handleChangeQuery">
                
                <Tree v-if="!loading&&data.length" :data="data" multiple @on-check-change="handleChange" show-checkbox check-directly
                    :render="renderContent"></Tree>
                    <!-- <div v-else-if="loading" style="text-align: center;">加载中...</div> -->
                <div v-else style="text-align: center;">暂无短剧</div>
            </Select>
        </Tooltip>
    </div>
</template>

<script>
import { getPrimaryPlays } from '@/api/play'
import { cloneDeep } from 'lodash';
export default {
    props: {
        value: {
            type: Array,
            default: () => []
        },
        defaultValue: {
            type: Object,
            default: () => ({})
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            data: [],
            treeValue: [],
            loading: false,
            originalValue: [],
            query: '',
            firstLoad:false
        }
    },
    model: {
        prop: 'value',
        event: 'update:value'
    },
    watch: {
        query() {
            this.handleGetPlay(this.query)
        },
        async defaultValue() {
            if (this.defaultValue.playCnName) {
                this.firstLoad = false
                await this.handleGetPlay(this.defaultValue.playCnName)
                if(this.value.length) return
                const v = []
                this.data.map(i => {
                    i.checked = true
                    v.push(i)
                    if(i.children&&i.children.length){
                        i.children.map(j=>v.push(j))
                    }
                    if(i.title == this.defaultValue.playCnName){
                        this.handleChange([],i)
                    }
                })
                
                this.treeValue = v.map(i=>i.value)
                this.firstLoad = true
            }
            
        }
    },
    methods: {
        renderContent(h, { root, node, data }) {
            return <div>
                {data.langName &&
                    <div style={{ display: 'inline-block', width: '4rem', textAlign: 'center', padding: '3px', color: '#fff', background: data.langColor, borderRadius: '90px', marginRight: '10px' }}>
                        {data.langName}
                    </div>}
                {data.title}
            </div>
        },
        handleChangeQuery(e) {
            this.$refs.selectRef.filterQueryChange = false
            this.$refs.selectRef.query = ''
            this.$refs.selectRef.$el.querySelector('.ivu-select-input').oninput = (a) => {
                if (a.inputType == 'deleteContentBackward' && !a.target.value) {
                    this.query = ''
                }
            }
            this.$refs.selectRef.$el.querySelector('.ivu-select-input').value = e
            if (e) {
                this.query = e
            }
        },
        handleChangeOption(e) {
            this.treeValue = e
            this.data = cloneDeep(this.data.map(i => {
                if (i.children.find(j => !e.includes(j.value))) {
                    i.checked = false
                }
                i.children = cloneDeep(i.children.map(j => {
                        return {
                            ...j,
                            checked: e.includes(j.value)
                        }
                    }))
                return i
            }))
            
            this.originalValue = this.$refs.selectRef.values
            this.$refs.selectRef.$el.querySelector('.ivu-select-input').focus()
            this.query = ''
            this.$emit('update:value', e)
        },
        handleChange(e, node) {
            // this.treeValue = e
            // if(!node||!node.children){
            //     return
            // }
            const li = e.map(i=>i.value)
            if (node && node.children) {
                if (!node.checked)
                    node.children.map(i => {
                        if (this.$refs.selectRef.values.map(i=>i.value).includes(i.value)) {
                            this.$refs.selectRef.onOptionClick({
                                label: i.title,
                                value: i.value
                            })
                        }
                    })
                else {
                    node.children.map(i => {
                        if (!this.$refs.selectRef.values.map(i=>i.value).includes(i.value)) {
                            this.$refs.selectRef.onOptionClick({
                                label: i.title,
                                value: i.value
                            })
                        }
                    })
                }
                return
            }
            if (node&&!node.parent)
                this.$refs.selectRef.onOptionClick({
                    label: node.title,
                    value: node.value
                })
            // this.$refs.selectRef.values = v
        },
        async handleGetPlay(playName,reset) {
            if(!playName) return
            this.loading = true
            await getPrimaryPlays({
                playName
            }).then(r => {
                const nodes = []
                this.data = r.data.map(i => {
                    return {
                        title: i.parentPlayName,
                        expand: true,
                        parent: true,
                        value: i.parentPlayId,
                        children: i.plays.map(j => {
                            if(this.treeValue.includes(j.id)){
                                nodes.push({
                                value: j.id,
                                title: j.playName,
                                })
                            }
                            return {
                                value: j.id,
                                langColor: j.langColor,
                                title: j.playName,
                                checked: this.treeValue.includes(j.id),
                                expand: true,
                                langName: j.langName
                            }
                        })
                    }
                })
                if(reset) this.$refs.selectRef.values = []
                console.log(this.data);
                
                this.$nextTick(()=>{
                    nodes.map(i=>{
                        this.handleChange([],i)
                    })
                })
                this.loading = false
            })
        },
    },
}
</script>

<style lang="less" scoped>
/deep/.ivu-tree-children {
    width: 100%;

    &>li {

        &>.ivu-tree-children {
            &>li {
                display: flex;
                align-items: center;
                // flex-wrap: wrap;
            }
        }
    }
}

/deep/.ivu-select-selection{
    &>div{
        display: flex;
    }
}
</style>